/**
 * UI Helper popover.
 *
 * Call a UI helper popover over an element within the UI.
 */
angular.module('hjApp.ui').service('UiHelper', [
    '$rootScope',
    '$timeout',
    function ($rootScope, $timeout) {
        /**
         * Call a UI helper popover over an element within the UI.
         *
         * @param identifier This identifier should be a unique name.
         *                   It is used to remember closed helpers in localStorage.
         *                   It is also used as the identifier for the anchor the
         *                   helper should be appended to in the UI.
         *                   This value should be the same as the value of `data-ui-helper-anchor` for the element you
         *                   want to display this next to.
         * @param title Title of Helper.
         * @param message Message of Helper.
         * @param placement 'bottom-left', bottom-right'.
         * @param customZIndex Custom Z index value.
         * @param positionAdjustment Position adjustment [top, left]. Example: '[5, 10]'
         * @param forceShow Force show the helper even if there is another helper in view.
         * @param alwaysShow If this is true, show the UI helper popover even after the first pop-over was displayed
         * @param [hideOnAnchorClick = true] Set to false if you want to make the user click close to hide this
         */
        this.show = function (
            identifier,
            title,
            message,
            placement,
            customZIndex,
            positionAdjustment,
            forceShow,
            alwaysShow,
            hideOnAnchorClick,
            ctaText,
            ctaFunction,
            showOnce
        ) {
            $timeout(function () {
                $rootScope.$emit(
                    'hjUiHelper',
                    identifier,
                    title,
                    message,
                    placement,
                    customZIndex,
                    positionAdjustment,
                    forceShow,
                    alwaysShow,
                    _.isUndefined(hideOnAnchorClick) || hideOnAnchorClick,
                    ctaText,
                    ctaFunction,
                    !!showOnce
                );
            }, 0);
        };

        /**
         * Hide any showing helper.
         */
        this.hide = function () {
            $rootScope.$emit('hideHelpers');
        };

        /**
         * Initializes any markers available on this state.
         */
        this.initMarkers = function () {
            $rootScope.$emit('initMarkers');
        };
    }
]);
